import { readConfig, e } from '@01/config'

export type Config = ReturnType<typeof get_config>
export const get_config = () =>
  readConfig(
    {
      app_version: e(String, '0.0.0'),
      site_key: e(String, '0x4AAAAAACIy-Y-iHJTLx9k6'),
      app_name: e(String),
      is_auth_enabled: e(Boolean, true),
      is_multitab: e(Boolean, false),
      company: {
        name: e(String, 'CineMachine'),
        domain: e(String, 'localhost')
      },
      footer: {
        prefix: '🇮🇳 Made in India'
      },
      identity: {
        api: e(String)
      },
      shootday: {
        api: e(String)
      }
    } as const,
    'VITE'
  )
